import { render, staticRenderFns } from "./homePageDetails.vue?vue&type=template&id=3583a15e&scoped=true"
import script from "./homePageDetails.vue?vue&type=script&lang=js"
export * from "./homePageDetails.vue?vue&type=script&lang=js"
import style0 from "./homePageDetails.vue?vue&type=style&index=0&id=3583a15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583a15e",
  null
  
)

export default component.exports